import { Typography } from "@mui/material";
import { sxTypographyAdvice } from "./sxProps";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";

const AdviceContainer: React.FC = () => {

    const accessibility = useAccessibility();

    return (
        <div className='advice-container' style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility}}>
            <div className='advice-text'  >
                <Typography style={accessibility.textStyleAccessibility} sx={sxTypographyAdvice}><b>Aviso!</b> Caso deseje identificar qual foi o procedimento realizado, acesse o menu “Meu plano / Informações de plano - PIN-SS / Utilização de serviços”.</Typography>
            </div>
        </div>
    )
}

export default AdviceContainer;